export const isNativeDatePickerSupported = () => {
  if (typeof window === 'undefined') return false

  const input = document.createElement('input')

  input.setAttribute('type', 'date')
  input.setAttribute('value', '2000-01-01')

  return !!input.valueAsDate
}
